import React, { PureComponent, Fragment } from 'react'
import cn from 'classnames'
import { Paper, List, ListItem, ListItemText, ListSubheader, Typography } from '@material-ui/core'
import red from '@material-ui/core/colors/red'

import { SourceListItem } from './components'
import { updateSources } from 'services/helpers'

export class SourcesBase extends PureComponent {
  state = {
    prevValue: 0
  }

  onFieldFocus = e => this.setState({ prevValue: +e.target.value })

  onFieldChange = id => e => {
    const { mergedSources, changeSourceData, company, routeCompany, showSnackbar, isUserWithFullAccess } = this.props

    if (!isUserWithFullAccess && company !== routeCompany) {
      showSnackbar({
        type: 'error',
        message: 'Доступ відсутній!'
      })

      return
    }

    const name = e.target.name
    const value = +e.target.value

    const updatedSources = updateSources(mergedSources, id, name, value)

    changeSourceData(updatedSources)
  }

  onFieldBlur = (id, label, limit) => e => {
    const { prevValue } = this.state
    const { mergedSources, setSourceData, changeSourceData, company, routeCompany, isUserWithFullAccess } = this.props

    if (!isUserWithFullAccess && company !== routeCompany) {
      return
    }

    const name = e.target.name
    let value = +e.target.value

    if (value < 0) {
      value = 0
    } else if (name === 'booked' && value < prevValue) {
      value = prevValue
    } else if (name === 'booked' && value > limit) {
      value = limit
    }

    const updatedSources = updateSources(mergedSources, id, name, value)
    changeSourceData(updatedSources)

    const diff = value - prevValue
    setSourceData({ name, diff, id, label })
  }

  listSubheader = () => {
    const { classes, booked, bookingsWithoutBlacklist, totalLimit } = this.props

    const bookedStyles = booked === bookingsWithoutBlacklist.length ? null : { color: red['A200'] }

    return (
      <ListSubheader className={classes.listHeader}>
        <div>Системи:</div>
        <div>
          <span style={bookedStyles}>
            {booked}
          </span>
          /{totalLimit}
        </div>
      </ListSubheader>
    )
  }

  renderSourceItem = source => (
    <SourceListItem
      key={source.id}
      source={source}
      onFocus={this.onFieldFocus}
      onBlur={this.onFieldBlur}
      onChange={this.onFieldChange}
    />
  )

  renderSources = () => {
    const { sheetBookings, sheetLimit, mergedSources } = this.props

    return (
      <Fragment>
        <ListItem disabled divider>
          <ListItemText primary='Відомість' />
          <Typography variant='subtitle1'>
            {sheetBookings.length}/{sheetLimit}
          </Typography>
        </ListItem>
        {mergedSources.map(this.renderSourceItem)}
      </Fragment>
    )
  }

  render() {
    const { classes, routeId, isDisabled } = this.props

    return (
      <Paper className={cn(classes.container, isDisabled && classes.disabled)}>
        <List dense subheader={this.listSubheader()}>
          {routeId
            ? this.renderSources()
            : (
              <ListItem>
                <ListItemText primary='Оберіть будь ласка маршрут' />
              </ListItem>
            )}
        </List>
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sources/Sources.js